import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const FORCE_GAME_STATE_MUTATION = gql`
	mutation($gameID: ID!, $forceActivation: Boolean) {
		forceGameStateChange(
			gameID: $gameID
			forceActivation: $forceActivation
		)
	}
`;

export default ({ children }) => (
	<Mutation mutation={FORCE_GAME_STATE_MUTATION} refetchQueries={['sessionGamesQuery']}>
		{forceGameStateChange => Propagator(children, forceGameStateChange)}
	</Mutation>
);
